import api from "utils/api";

export const getSpiffSettings = async () => {
  try {
    const response = await api.get("/spiff/settings");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateSpiffSettings = async (data) => {
  try {
    const response = await api.put("/spiff/settings", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const resetSpiffSettings = async () => {
  try {
    const response = await api.post("/spiff/settings/reset");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllSpiffProgress = async (params = {}) => {
  try {
    const response = await api.get("/spiff", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSpiffStats = async () => {
  try {
    const response = await api.get("/spiff/stats");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const processSpiffPayout = async (id, formData) => {
  try {
    const response = await api.put(`/spiff/${id}/process`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getTutorSpiffStatus = async (tutorId) => {
  try {
    const response = await api.get(`/spiff/tutor/${tutorId}/status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const requestSpiffWithdraw = async (progressId, data = {}) => {
  try {
    const response = await api.post(`/spiff/${progressId}/withdraw`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
